export const MODIFY_ORDER = 'MODIFY_ORDER'
export const SAMPLE_ORDERS = 'sample_orders'
export const OFFER_BUNDLE_PRICE_OVERRIDE = 'offer_bundle_price_override'
export const ACCOUNTING_TAB = 'accounting_tab'
